import { gql } from 'apollo-angular'

export const DELETE_SEAT_ALLOCATION = gql`
  mutation DeleteSeatAllocation($seatAllocationId: Int!) {
    deleteSeatAllocation(id: $seatAllocationId) {
      id
    }
  }
`
